// Module
var code = "<div class=\"performance-status-icon\">\r\n    <span class=\"icon iconStatus\" data-bind=\"css: cssClass\">\r\n        <img class=\"print\" alt=\"\" data-bind=\"attr: {src: iconImageSrc}\">\r\n    </span>\r\n    <!-- ko if: showText -->\r\n    <span data-bind=\"text: displayText\"></span>\r\n    <!-- /ko -->\r\n</div>\r\n";
// Exports
module.exports = code;